import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/metaPixel';
import { gaPageView } from '../utils/googleAnalytics';

/**
 * Mounted v App. Pri každej zmene URL pošle page view do analytických nástrojov —
 * Meta Pixel (len pri marketingovom súhlase) a Google Analytics (len pri
 * analytickom súhlase). Každý si consent overuje sám.
 */
export function MetaPixelTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView();
    gaPageView();
  }, [location.pathname, location.search]);
  return null;
}
